export const SnoozeStatus = {
  all: '全て',
  todo: 'TODO',
  snoozed: 'スヌーズ中'
} as const;

export type SnoozeStatusKey = keyof typeof SnoozeStatus;

export const SnoozeStatusKeys: readonly SnoozeStatusKey[] = ['all', 'todo', 'snoozed'];
